import { api } from "@/api";
import { useState, useEffect } from "react";
import { RenderMarkdown } from "../Chat/ChatHelpers";
import { useNavigate } from "react-router";
import type { Workflow } from "@butler/shared";

export function WorkflowTools({ workflow }: { workflow: Workflow }) {
  return (
    <div className="space-y-4">
      <div className="rounded-md border p-2 space-y-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="flex-shrink-0 h-8 w-8 bg-blue-50 dark:bg-blue-900/20 rounded flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-4 w-4 text-blue-600 dark:text-blue-400"
                aria-label="Function"
              >
                <title>Function Icon</title>
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium truncate">All Tools</p>
              <p className="text-[10px] text-gray-500">TypeScript</p>
            </div>
          </div>
        </div>
        {/* There can be multiple triggers, so we need to show them all */}
        {workflow.tools === null ? (
          <div className="text-xs text-gray-500 p-2 bg-gray-50 dark:bg-gray-900 rounded">
            Loading...
          </div>
        ) : (
          workflow.tools.map((tool) => (
            <div className="font-mono text-xs overflow-auto max-h-[200px] p-2 bg-gray-50 dark:bg-gray-900 rounded">
              <RenderMarkdown
                content={`\`\`\`typescript\n${JSON.stringify(tool)}\`\`\``}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
